import { DefaultButton, PrimaryButton, Spinner, Stack, Text } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { store, useAppSelector } from '../../../App/store';
import { getAsync, postAsync } from '../../../utils/api';
import { setFormsActiveAccount } from '../../Forms/slice/newFormReducers';
import ReturnableText from '../../ReturnableText';
import { actions } from '../slice';
import AccountForm from './Components/AccountForm';
import getFormData from './Components/get-form-data';

const Buttons = (props: { disabled: boolean }) => {
  return (
    <>
      <DefaultButton
        text="Düzenlemeden Devam Et"
        onClick={setFormActiveAccount}
        disabled={props.disabled}
      />
      <PrimaryButton
        text="Düzenle"
        onClick={submit}
        disabled={props.disabled}
      />
    </>
  );
};

export default () => {
  const activeAccountId = useAppSelector(
    (state) => state.accounts.activeAccountId
  );
  const [dataFetched, setDataFetched] = useState(false);

  useEffect(() => {
    fetchApplyData().then(() => setDataFetched(true));
  }, [setDataFetched]);

  return (
    <Stack tokens={stackTokens}>
      <Text variant="large">
        <ReturnableText text="Hesap Düzenle" onClick={actions.reset} />
        &nbsp;
        <small>#{activeAccountId}</small>
      </Text>
      {dataFetched ? (
        <AccountForm buttons={Buttons} />
      ) : (
        <Spinner label="Son hali yükleniyor" />
      )}
    </Stack>
  );
};

const stackTokens = { childrenGap: 15 };
const fetchApplyData = async () => {
  const activeAccountId = store.getState().accounts.activeAccountId;
  if (!activeAccountId) throw "invalid account id";

  const { data } = await getAsync("/accounts/get?id=" + activeAccountId);
  const formData: any = {
    name: data.name,
    citizenIdNumber: data.citizenId,
    mailAddress: data.email,
    shipmentAddress: data.shipmentAddress,
    invoiceAddress: data.invoiceAddress,
    taxAdminId: data.taxAdminId,
    companyName: data.companyName,
  };

  data.phones?.map((phone: string, index: number) => {
    const [countryCode, ...number] = phone.split(" ");

    formData[`phone${index}CountryCode`] = countryCode;
    formData[`phone${index}Number`] = number.join(" ");
  });

  actions.setAllAccountVariables(formData);
};
const setFormActiveAccount = () => {
  const activeAccountId = store.getState().accounts.activeAccountId;
  if (!activeAccountId) throw "invalid account id";

  setFormsActiveAccount(activeAccountId);
};
const submit = async () => {
  const activeAccountId = store.getState().accounts.activeAccountId;
  if (!activeAccountId) throw "invalid account id";

  actions.setSubmitDisabled(true);

  const data = await getFormData();

  if (!data) {
    actions.setSubmitDisabled(false);
    return;
  }

  const submitRes = await postAsync(
    "/accounts/edit?id=" + activeAccountId,
    data
  );

  if (!submitRes.success || !submitRes.versionId) {
    alert("Hesap düzenlenemedi");
    return;
  }

  actions.reset();
  actions.setActiveAccountId(activeAccountId);

  setFormsActiveAccount(activeAccountId, submitRes.versionId);
};
